import { useState } from 'react';
import { serviceByIdQuery } from './serviceByIdQuery';
import { useQuery, removeConnectionsMemoized } from 'shared/apollo';

export function useServiceByIdQuery(id) {
  if (!id) {
    return useState({})[0];
  }

  const query = useQuery(serviceByIdQuery, { id });
  const results = removeConnectionsMemoized(query?.allServices);
  return results?.filter(x => x.dbId === id)[0];
}

